const Ajax = require('common/infra/ajax');

class API {
    /**
     * Task 一覧を取得する
     *
     * @param limit {number}
     * @param cursor {string}
     * @returns {*}
     */
    fetch(limit, cursor) {
        const path = `/api/my/task-statuses`;
        let params = new URLSearchParams();

        params.append('limit', limit);
        if(cursor) {
            params.append('nextCursor', cursor);
        }

        return Ajax.GET(`${path}?${params.toString()}`);
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./my/infra/api/task.js